import {AppSettingsRepo, SettingsKeys} from "../../domain/settings/IAppSettingsRepo";

const isLoggedIn = async () => {
    const token = await AppSettingsRepo.get(SettingsKeys.authToken);
    return !!token;
}

export default isLoggedIn;